import React from 'react'

import { Alert } from '@cinch-labs/design-system'
import BookingScheduler from '@cinch/oxd-components/booking-scheduler/src'
import SiteAddress from '@cinch/oxd-components/booking-site-address/src'
import Panel, { PanelLevel } from '@cinch/oxd-components/panel/src'

import useBooking from './booking.hooks'

// @ts-check
import * as styles from './booking-panel.module.css'

const i18n = {
  selectLabel: 'Select branch and date',
  milesAway: 'miles away',
  select: 'Select',
  back: 'Back to branch & date',
  changePostcode: 'Change postcode',
  updatePostcode: 'Update',
  cancel: 'Cancel',
  dateLabel: 'Select a date',
  timeLabel: 'Select a time',
}

const API_ERROR_MESSAGE = 'Currently unable to find any available appointments. Please try again later'

const BookingPanel: React.FC<{
  vehiclePriceOffered: number
  customerPostcode: string
  level?: PanelLevel
  onSubmit: any
}> = ({ vehiclePriceOffered, customerPostcode, level = PanelLevel.low, onSubmit }) => {
  const { isLoading, isSiteLoading, sites, site, handlePostcodeChange, handleSiteSelect, hasError } = useBooking(
    customerPostcode,
    vehiclePriceOffered,
  )

  const formContent = (
    <>
      <div className={styles.form}>
        <BookingScheduler
          i18n={i18n}
          sites={sites}
          onPostcodeChange={handlePostcodeChange}
          onSiteSelect={handleSiteSelect}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
      </div>
      <SiteAddress isLoading={isSiteLoading} site={site} />
    </>
  )

  return (
    <Panel title={'Book to sell your car'} isPadded={true} className={styles.panel} level={level}>
      <div className={styles.body}>
        {!hasError && formContent}
        {hasError && <Alert oxford={true}>{API_ERROR_MESSAGE}</Alert>}
      </div>
    </Panel>
  )
}

export default BookingPanel
